const lightStyles = {
  table: {
    style: {
      backgroundColor: "#ffffff",
    },
  },
  tableWrapper: {
    style: {
      display: "block",
    },
  },
  headRow: {
    style: {
      background: "linear-gradient(135deg, #2a3c7d 0%, #3d5294 100%)",
      color: "#ffffff",
      borderBottom: "none",
      minHeight: "46px",
    },
  },
  headCells: {
    style: {
      whiteSpace: "nowrap",
      overflow: "visible",
      textOverflow: "clip",
      lineHeight: "1.4",
      fontWeight: 600,
      fontSize: "0.8125rem",
      letterSpacing: "0.01em",
      textTransform: "none",
      paddingLeft: "16px",
      paddingRight: "16px",
      border: "none",
      color: "#ffffff",
      justifyContent: "flex-start",
    },
  },
  rows: {
    style: {
      minHeight: "54px",
      fontSize: "0.875rem",
      color: "#334155",
      backgroundColor: "#ffffff",
      borderBottom: "1px solid #e8edf5",
      transition: "background-color 0.12s ease",
    },
    stripedStyle: {
      backgroundColor: "#f8fafc",
    },
    highlightOnHoverStyle: {
      backgroundColor: "#eef3ff",
      borderBottomColor: "#dde5f5",
      outline: "none",
      cursor: "pointer",
    },
  },
  cells: {
    style: {
      whiteSpace: "normal",
      wordBreak: "break-word",
      fontSize: "0.875rem",
      lineHeight: "1.45",
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: "10px",
      paddingBottom: "10px",
      border: "none",
      color: "#334155",
      justifyContent: "flex-start",
    },
  },
  pagination: {
    style: {
      borderTop: "1px solid #e8edf5",
      minHeight: "54px",
      fontSize: "0.8125rem",
      color: "#64748b",
      backgroundColor: "#fafbfd",
    },
  },
};

const darkStyles = {
  table: {
    style: {
      backgroundColor: "#1e2124",
    },
  },
  tableWrapper: {
    style: {
      display: "block",
    },
  },
  headRow: {
    style: {
      background: "linear-gradient(135deg, #1a2447 0%, #2a3c7d 100%)",
      color: "#ffffff",
      borderBottom: "none",
      minHeight: "46px",
    },
  },
  headCells: {
    style: {
      whiteSpace: "nowrap",
      overflow: "visible",
      textOverflow: "clip",
      lineHeight: "1.4",
      fontWeight: 600,
      fontSize: "0.8125rem",
      letterSpacing: "0.01em",
      textTransform: "none",
      paddingLeft: "16px",
      paddingRight: "16px",
      border: "none",
      color: "#ffffff",
      justifyContent: "flex-start",
    },
  },
  rows: {
    style: {
      minHeight: "54px",
      fontSize: "0.875rem",
      color: "#d8deea",
      backgroundColor: "#1e2124",
      borderBottom: "1px solid #3a4155",
      transition: "background-color 0.12s ease",
    },
    stripedStyle: {
      backgroundColor: "#23262a",
    },
    highlightOnHoverStyle: {
      backgroundColor: "#2a3148",
      borderBottomColor: "#4a5268",
      outline: "none",
      cursor: "pointer",
    },
  },
  cells: {
    style: {
      whiteSpace: "normal",
      wordBreak: "break-word",
      fontSize: "0.875rem",
      lineHeight: "1.45",
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: "10px",
      paddingBottom: "10px",
      border: "none",
      color: "#d8deea",
      justifyContent: "flex-start",
    },
  },
  pagination: {
    style: {
      borderTop: "1px solid #3a4155",
      minHeight: "54px",
      fontSize: "0.8125rem",
      color: "#a8b4c8",
      backgroundColor: "#23262a",
    },
  },
};

export const getCmsDataTableStyles = (theme = "light") =>
  theme === "dark" ? darkStyles : lightStyles;

/** @deprecated Use getCmsDataTableStyles(theme) */
export const cmsDataTableStyles = lightStyles;
